import {
  PromoCase,
  SearchItemPromo,
  SearchPromoTypes,
} from 'common-constants/promoCases'
import { buildPromoStruct } from 'components/page/Search/function/buildPromoStructure'

export const getPromoService = (promoCase: PromoCase): SearchItemPromo =>
  buildPromoStruct(SearchPromoTypes.Service, promoCase)
